import React, { useState } from "react";

import { AuthEmailForm, AuthLayout, OnEmailFormSubmitFunction } from "../AuthLayouts";
import { showErrorToast } from "../../../shared/Toasts";
import { fetchWithoutAuth, FormErrorData } from "../../../../api-client/APIClient";

const SendResetPasswordScreen = () => {
  const [resetPasswordSuccess, setResetPasswordSuccess] = useState(false);

  const handleSubmit: OnEmailFormSubmitFunction = (
    data,
    setEmailErrorMessage,
    setEmailFormIsLoading,
  ) => {
    setEmailFormIsLoading(true);
    fetchWithoutAuth({
      path: "/users/password/send-reset",
      method: "POST",
      body: { email: data.email },
      onResponse: () => {
        setEmailFormIsLoading(false);
        setResetPasswordSuccess(true);
      },
      onError: (err: Response | undefined) => {
        if (err) {
          err.json().then((data: FormErrorData) => {
            if (data.non_field_errors) {
              setEmailErrorMessage(data.non_field_errors[0]);
            } else if (data.email) {
              setEmailErrorMessage(data.email[0]);
            }
            showErrorToast("Failed to reset password.");
            setEmailFormIsLoading(false);
          });
        } else {
          showErrorToast("Something went wrong, please check your connection and try again.");
          setEmailFormIsLoading(false);
        }
      },
    });
  };

  if (!resetPasswordSuccess) {
    return (
      <AuthEmailForm
        title="Forgot password"
        description="Get a link to reset your password"
        onEmailFormSubmit={handleSubmit}
      />
    );
  }

  return (
    <AuthLayout
      title="Forgot password"
      description="We've emailed you instructions to reset your password"
    />
  );
};

export default SendResetPasswordScreen;
